import { WorkbookNavItem } from '../⚛️atoms/WorkbookNavItem.jsx';
import { useEffect, useRef, useState } from 'react';
import { WorkbookNavItemScrollArea } from '../❉molecules/WorkbookNavItemScrollArea.jsx';
import { WorkbookNavChapterGroup } from '../❉molecules/WorkbookNavChapterGroup';
import { useClickAway } from 'react-use';
import { ChevronRightIcon } from '@heroicons/react/24/outline';

export const WorkbookNav = ({ sections = [], currentSection, expandNav, onClick }) => {
  const navRef = useRef(null);
  useClickAway(navRef, () => {
    hideDropdown();
  });

  const [showDropdown, setShowDropdown] = useState(false);

  let currentItem;
  let currentChapter;
  if (currentSection) {
    currentItem = sections.flatMap((section) => section.items).find((item) => item._id === currentSection?._id);
    currentChapter = sections.find((section) =>
      section.items.find((item) => item._id === currentItem?._id && !item.completed)
    );
  } else {
    currentChapter = sections.find((section) => !section.completed);
    currentItem = currentChapter?.items?.find((item) => !item.item_id.completed);
  }

  useEffect(() => {
    setShowDropdown(expandNav);
  }, [expandNav]);

  useEffect(() => {
    onClick(currentItem);
  }, []);

  const hideDropdown = () => {
    setShowDropdown(false);
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };
  return (
    <>
      <div className="relative z-50 flex h-full w-full bg-white" ref={navRef}>
        {showDropdown && (
          <>
            <div className="fixed top-0 left-0 h-screen w-screen backdrop-blur-[2px]" onClick={toggleDropdown}></div>
            <div onClick={toggleDropdown} className="absolute top-0 left-0 z-50 h-full w-full lg:w-2/3">
              <WorkbookNavItemScrollArea>
                {sections.map((section, index) => {
                  return (
                    <WorkbookNavChapterGroup
                      currentItem={currentItem}
                      currentChapter={currentChapter}
                      section={section}
                      key={index}
                      onClick={onClick}
                    />
                  );
                })}
              </WorkbookNavItemScrollArea>
            </div>
          </>
        )}
        <div onClick={toggleDropdown} className="flex w-full items-center pl-5">
          <ChevronRightIcon
            className="z-30 size-10 rounded-lg bg-white transition-[rotate] data-[show=true]:rotate-90"
            onClick={toggleDropdown}
            data-show={showDropdown}
          />
          <WorkbookNavItem
            title={typeof currentSection === 'string' ? currentSection : currentChapter?.title}
            subtitle={currentItem?.title}
            current={true}
            key={currentItem}
            completed={currentItem?.item_id.completed}
            showCompleted={false}
          />
        </div>
      </div>
    </>
  );
};
